import {ModuleComponent} from "../../js/module-component";

export class ModHeroVideo extends ModuleComponent{
    ready(){
        super.ready();

/*        const $videoImage = this.findMember("video-image");
        $videoImage.attr("style",$videoImage.data("style"));*/
    }
}